module.exports = __webpack_public_path__ + "static/media/referrals-md.b0511115.png";